import React, { useCallback, useContext, useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { ParentScreenCtx } from '../../../pages/workbench_build/WorkbenchBuild';
import {
    Accordion,
    Autocomplete,
    Box,
    Button,
    MenuItem,
    FormControl,
    Stack,
    TextField,
    Select,
    InputLabel,
    AccordionSummary,
    AccordionDetails,
    Typography,
    Alert,
    Snackbar
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import { convertCaseOptionsArray, errorArray, fieldTypeOptionsArray, fillCharacterDropDown, outboundFieldTypeOptionsArray, paddingDirectionArray } from '../../../constants/constantList';
import ReplacementModal from './Advanced Properties/ReplacementModal';
import TPCheckbox from "../../TemplateProperties/TPCheckbox";
import { SectionHeader } from './SectionHeader';
import { LOOP_RECORD } from '../../../constants/loopRecordOptions';
import AdvancedProperties from './Advanced Properties/AdvancedProperties';
import SourceType from '../../TemplateProperties/SourceType';
import { api } from '../../../redux/api';
import DatePattern from '../PatternModal/DatePattern';
import { lgDocPath } from '../../../constants/languageDocPaths';
import { cloneDeep, debounce, isEqual } from 'lodash';
import { eachDeep } from "deepdash-es/standalone";
import { treeActions } from '../../../redux/slices/treeSlice';
import VariableCollection from '../OutboundRecordProperties/VariableCollection';
import CustomDBField from '../OutboundRecordProperties/CustomDBField';
import SourceTypeInboundDataRenderer from '../../TemplateProperties/SourceTypeComponents/SourceTypeInboundDataRenderer';
import { filterOutNodeTypes, stringToBooleanConversion } from '../../../utils/utilFunctions';
import { filterNodes } from '../OutboundRecordProperties/OutboundRecordProperties';
import { inboundTemplateToRcTree } from '../../../utils/rctreeDataConversion';
import { AddToDataDepot } from './OutboundFieldFormattingOptions/AddToDataDepot';

const styles = {
    fpContainer: {
        // padding: "0 16px 16px 16px"
        padding: "0 4px 4px 4px",
    },
    accordianContainer: {
        border: "none",
        padding: "0",
        margin: "0",
        boxShadow: "none",
        backgroundColor: "unset",
    },
    accordianHeader: {
        border: "none",
        padding: "0",
        margin: "0",
        backgroundColor: "unset",
    },
    accordianContent: {
        border: "none",
        padding: "0 0px",
        margin: "0",
        backgroundColor: "unset",
    },
};

const ElementProperties = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const parentScreen = useContext(ParentScreenCtx);
    const { rightTree } = useSelector((state) => state.treeData[parentScreen]);
    const DEPENDENCIES = useSelector(state => state.treeData.outbound.rightTree.tree.templateHeader?.DEPENDENCIES || '');
    const selectedNode = rightTree.tree[rightTree.currentTab].selectedNode;
    const translatedData = rightTree.tree[rightTree.currentTab].translatedData;
    const queryParams = useSelector((state) => state.queryParams);
    const templateHeader = rightTree.tree.templateHeader;
    let docPath = `${queryParams.baseUrl}/docs/${lgDocPath[queryParams.lang] || 'en'}/Workbench/dialogs/DateFormatter.html`;

    // const [depotField, setDepotField] = useState(selectedNode.DATA_DEPOT_FIELD ? [selectedNode.DATA_DEPOT_FIELD] : []);
    // const [dataDepotOptions, setDataDepotOptions] = useState(selectedNode.DATA_DEPOT ? [selectedNode.DATA_DEPOT] : []);
    const [fieldTypeDropDownItems, setFieldTypeDropDownItems] = useState([]);
    const [fieldTypeOptions, setFieldTypeOptions] = useState([]);
    const [elementName, setElementName] = useState('');
    const [attributeName, setAttributeName] = useState('');
    const [loopRecordOptions, setLoopRecordOptions] = useState([]);
    const [loopRecordValue, setLoopRecordValue] = useState('');
    const [loopCounter, setLoopCounter] = useState(false);
    const [resetLoop, setResetLoop] = useState(false);
    const [fieldType, setFieldType] = useState('');
    const [sessionValue, setSessionValue] = useState('');
    const [applyFieldProperty, setApplyFieldProperty] = useState(false);
    const [constantValue, setConstantValue] = useState('');
    const [convertCase, setConverCase] = useState('');
    const [paddingDirectionOptions, setPaddingDirectionOptions] = useState([]);
    const [paddingDirectionDropdown, setPaddingDirectionDropdown] = useState('');
    const [convertCaseOptions, setConvertCaseOptions] = useState([]);
    const [convertCaseDropdown, setConvertCaseDropdown] = useState([]);
    const [errorOptions, setErrorOptions] = useState([]);
    const [errorDropdown, setErrorDropdown] = useState([]);
    const [paddingDirection, setPaddingDirection] = useState('');
    const [openDelimiterDialog, setDelimiterDialog] = useState(false);
    const [repeatTimes, setRepeatTimes] = useState(1);
    const [length, setLength] = useState(0);
    const [fillCharacter, setFillCharacter] = useState('');
    const [error, setError] = useState('');
    const [defaultValue, setDefaultValue] = useState('');
    const [sourceNodeInfo, setSourceNodeInfo] = useState({ FIELDTYPE: "ALPHA" });
    const [date, setDate] = useState('');
    const [inboundDate, setInboundDate] = useState('');
    const [datePatternModal, setDatePatternModal] = useState(false);
    const [inboundDatePatternModal, setInboundDatePatternModal] = useState(false);
    const [inboundDatePattern, setInboundDatePattern] = useState('');
    const [datePattern, setDatePattern] = useState('');
    const [valid, setValid] = useState(true);
    const [dpNetworkCallMessage, setDpNetworkCallMessage] = useState('');
    const [flag, setFlag] = useState(false);
    const [inboundPrecision, setInboundPrecision] = useState(0);
    const [outboundPrecision, setOutboundPrecision] = useState(0);
    const [showAlert, setShowAlert] = useState({ mssg: '', type: 'success', isOpen: false });

    // Loop Record
    const [isLoading, setIsLoading] = useState(true);
    const [datePatternLoader, setDatePatternLoader] = useState(false);
    const { account } = useSelector(state => state?.queryParams || '');
    const [showCheckbox, setShowCheckbox] = useState(true);
    const [tab, setTab] = useState('');
    const [expandActions, setExpandActions] = useState({ tab: '', keys: [] });
    const [treeData, setTreeData] = useState({ header: [], body: [], trailer: [] });
    const inboundTemplateTree = useSelector(state => state.treeData.inbound.leftTree.tree.body.translatedData);

    // Checkboxes
    const [cdataElement, setCDataElement] = useState(false);
    const [trimData, setTrimData] = useState(true);
    const [urlEncodedData, setUrlEncodedData] = useState(false);
    const [reportTransactionError, setReportTransactionError] = useState(true);
    const [allowRounding, setAllowRounding] = useState(true);
    const [suppressElements, setSupressElements] = useState(false);
    const [suppressAttribute, setSupressAttribute] = useState(false);
    const [addToWorkflow, setAddToWorkflow] = useState(false);
    const [escapeXmlData, setEscaepXmlData] = useState(true);
    const [quoteData, setQuoteData] = useState(true);
    const [suppressTrailing, setSuppressTrailing] = useState(false);
    const [ignoreGlobal, setIgnoreGlobal] = useState(false);
    const [fieldRequired, setFieldRequired] = useState(false);
    // const [addDataDepot, setAddDataDepot] = useState(false);
    // const [dataDepotValue, setDataDepotValue] = useState('');
    // const [dataFieldValue, setDataFieldValue] = useState('');

    const fillCharacterOptions = fillCharacterDropDown.map((e, i) => {
        return { value: e?.value, label: t(e?.text) };
    });

    const submitChange = (key, val) => {
        if (key !== "ELEMENT_NAME" &&
            key !== "ATTRIBUTE_NAME" &&
            key !== "FIELDTYPE" &&
            key !== 'LOOP_REC_OPTIONAL' &&
            key !== 'CREATE_COUNTER_FOR_LOOP' &&
            key !== 'RESET_LOOP' &&
            key !== 'VALUE' &&
            key !== 'REPEAT' &&
            key !== 'LENGTH' &&
            key !== 'CDATA_ELEM' &&
            key !== 'TRIM_DATA' &&
            key !== 'URL_ENCODE_DATA' &&
            key !== 'REPORT_TRUNCATION_ERRORS' &&
            key !== 'ALLOW_ROUNDING_FOR_FLOAT' &&
            key !== 'SUPPRESS_EMPTY_RECORDS' &&
            key !== 'ESCAPE_XML' &&
            key !== 'QUOTE_DATA' &&
            key !== 'SUPPRESS_TRAILING_FLD_DELIM' &&
            key !== 'IGNORE_GLOBAL_SUB' &&
            key !== 'FLD_REQ' &&
            key !== 'ADD_TO_WF_SESSION' &&
            key !== 'APPLY_FIELD_PROPERTIES' &&
            key !== 'DATA_DEPOT' &&
            key !== 'DATA_DEPOT_FIELD' &&
            key !== 'INBOUND_DATE_PATTERN' &&
            key !== 'DATE_PATTERN' &&
            key !== 'CONVERT_CASE' &&
            key !== 'PADDIR' &&
            key !== 'FILLCHAR' &&
            key !== 'INPRECISION' &&
            key !== 'OUTPRECISION' &&
            key !== 'ON_ERROR' &&
            key !== 'DEFAULT_VALUE' &&
            key !== 'WF_SESSION_NAME' &&
            key !== 'ADVANCE') return;

        const updatedData = eachDeep(cloneDeep(translatedData), (objValue) => {
            if (objValue?.key !== selectedNode.key) {
                return;
            }
            if (key === "ELEMENT_NAME") {
                objValue[key] = val;
                objValue['title'] = `<${val}>`;
            } else if (key === 'ATTRIBUTE_NAME') {
                objValue[key] = val;
                objValue['title'] = val;
            } else if (key === 'FIELDTYPE"') {
                objValue[key] = val;
            } else if (key === "LOOP_REC_OPTIONAL") {
                objValue[key] = val;
            } else if (key === 'CREATE_COUNTER_FOR_LOOP') {
                objValue[key] = val;
            } else if (key === 'RESET_LOOP') {
                objValue[key] = val
            } else if (key === 'VALUE') {
                objValue[key] = val
            } else if (key === 'REPEAT') {
                objValue[key] = val
            } else if (key === 'LENGTH') {
                objValue[key] = val
            } else if (key === 'CDATA_ELEM') {
                objValue[key] = val
            } else if (key === 'TRIM_DATA') {
                objValue[key] = val
            } else if (key === 'URL_ENCODE_DATA') {
                objValue[key] = val
            } else if (key === 'REPORT_TRUNCATION_ERRORS') {
                objValue[key] = val
            } else if (key === 'ALLOW_ROUNDING_FOR_FLOAT') {
                objValue[key] = val
            } else if (key === 'SUPPRESS_EMPTY_RECORDS') {
                objValue[key] = val
            } else if (key === 'ESCAPE_XML') {
                objValue[key] = val
            } else if (key === 'QUOTE_DATA') {
                objValue[key] = val
            } else if (key === 'SUPPRESS_TRAILING_FLD_DELIM') {
                objValue[key] = val
            } else if (key === 'IGNORE_GLOBAL_SUB') {
                objValue[key] = val
            } else if (key === 'FLD_REQ') {
                objValue[key] = val
            } else if (key === 'ADD_TO_WF_SESSION') {
                objValue[key] = val
            } else if (key === 'APPLY_FIELD_PROPERTIES') {
                objValue[key] = val
            } else if (key === 'INBOUND_DATE_PATTERN') {
                objValue[key] = val
            } else if (key === 'DATE_PATTERN') {
                objValue[key] = val
            } else if (key === 'CONVERT_CASE') {
                objValue[key] = val
            } else if (key === 'PADDIR') {
                objValue[key] = val
            } else if (key === 'FILLCHAR') {
                objValue[key] = val
            } else if (key === 'INPRECISION') {
                objValue[key] = val
            } else if (key === 'OUTPRECISION') {
                objValue[key] = val
            } else if (key === 'ON_ERROR') {
                objValue[key] = val
            } else if (key === 'DEFAULT_VALUE') {
                objValue[key] = val
            } else if (key === 'WF_SESSION_NAME') {
                objValue[key] = val
            } else if (key === 'ADVANCE') {
                objValue['SUBSTRING'] = val?.SUBSTRING;
                objValue['FUNCTION'] = val?.FUNCTION;
                objValue['MASK'] = val?.MASK;
                objValue['REPLACE'] = val?.REPLACE;
                objValue['ADVANCE'] = val;
            } else objValue[key] = val || selectedNode[key];
            dispatch(
                treeActions.setRightTreeSelectedNode({
                    screen: parentScreen,
                    type: rightTree.currentTab,
                    data: objValue,
                })
            );
        });
        dispatch(
            treeActions.setNewRightTreeTranslatedData({
                screen: parentScreen,
                type: rightTree.currentTab,
                data: updatedData,
            })
        );
    };

    const debounceChangeHandler = useCallback(debounce(submitChange, 200), [
        rightTree.currentTab,
        rightTree.tree,
    ]);

    // const dataDepotHandler = (key, val, deleteDataDepo) => {
    //     let newData = cloneDeep(translatedData);
    //     eachDeep(newData, (obj) => {
    //         if (obj?.key === selectedNode.key) {
    //             if (key === "DATA_DEPOT") {
    //                 obj[key] = val;
    //             } else if (key === "DATA_DEPOT_FIELD") {
    //                 setDataFieldValue(val);
    //                 obj[key] = val;
    //                 // Update the DATA_DEPOT value if it is not already set
    //                 if (!obj.DATA_DEPOT) {
    //                     obj.DATA_DEPOT = dataDepotValue;
    //                 }
    //             } else if (key === 'ADD_TO_DATA_DEPOT') {
    //                 obj[key] = val;
    //             } else if (deleteDataDepo) {
    //                 if (obj?.DATA_DEPOT) delete obj.DATA_DEPOT
    //                 if (obj?.DATA_DEPOT_FIELD) delete obj.DATA_DEPOT_FIELD
    //             } else {
    //                 obj[key] = dataFieldValue;
    //             }
    //         }
    //     });
    //     dispatch(
    //         treeActions.setNewRightTreeTranslatedData({
    //             screen: parentScreen,
    //             type: rightTree.currentTab,
    //             data: newData,
    //         })
    //     );
    // };

    const handleDelimiterDialog = (val) => {
        if (val === '') setConstantValue(' ');
        else {
            setConstantValue(val);
            debounceChangeHandler('VALUE', val);
        }
        setDelimiterDialog(false);
    }

    const datePatternModalCancelHandler = () => {
        setDatePatternModal(false);
    };

    const dateInboundPatternModalCancelHandler = () => {
        setInboundDatePatternModal(false);
    };

    const inboundDatePatternModalOkHandler = () => {
        if (flag) {
            setInboundDate(inboundDatePattern);
            setInboundDatePatternModal(!inboundDatePatternModal);
            debounceChangeHandler('INBOUND_DATE_PATTERN', inboundDatePattern);
        } else {
            setInboundDate(selectedNode.INBOUND_DATE_PATTERN || inboundDate);
            setInboundDatePatternModal(!inboundDatePatternModal);
        }
    };

    const datePatternModalOkHandler = () => {
        if (flag) {
            setDate(datePattern);
            setDatePatternModal(!datePatternModal);
            debounceChangeHandler('DATE_PATTERN', datePattern);
        } else {
            setDate(selectedNode.DATE_PATTERN || date);
            setDatePatternModal(!datePatternModal);
        }
    };

    const testDateHandler = (key, val) => {
        if (!val) {
            setDpNetworkCallMessage(t('BOX_NO_FORMAT_WAS_SPECIFIED__SEL_CANCEL_TO_CLS_DIALOG_AND_RET_TO_MAIN_SCREEN'))
            setValid(false)
        }
        if (val) {
            setDatePatternLoader(true);
            dispatch(
                api.endpoints.validateDatePattern.initiate({
                    datePattern: encodeURIComponent(val),
                })
            ).then((response) => {
                if (response) {
                    if (response.data.current_state === 'ERROR') {
                        setValid(false)
                        setFlag(false)
                        setDpNetworkCallMessage(response.data.message)

                    } else {
                        if (key === 'fromModal') {
                            setFlag(true)
                            setDpNetworkCallMessage(response.data.message)
                        }
                        setValid(true)
                    }
                }
            }).finally(() => setDatePatternLoader(false));
        }
    };

    const handleDelimiterDialogValue = (val) => {
        setConstantValue(val);
        debounceChangeHandler('VALUE', val);
    }

    const handleLoopRecordChange = (e) => {
        const value = e.target.value;
        setLoopRecordValue(value);
    };

    const updatedSelectedNodeWithAdvanceProperties = (val) => {
        debounceChangeHandler('ADVANCE', val);
    }

    const sourceTypeValueChange = (values) => {
        setSourceNodeInfo(values);
        const { PARENT, MAPNAME, RECORD_TYPE, ACTION, INDEX, MAP_REPETITION_INDEX, CUSTOM_DB_FIELD, PLUGIN_NAME, WF_ITEM_ID, WF_ITEM_LOCATION, SOURCE_REPEATING_FIELD} = values;
        let newSelNode = false;
        const updatedTranslatedData = eachDeep(cloneDeep(translatedData), (obj) => {
            if (obj && obj.key === selectedNode.key) {
                obj.PARENT = PARENT || undefined;
                obj.RECORD_TYPE = RECORD_TYPE
                obj.MAPNAME = MAPNAME;
                obj.ACTION = ACTION;
                obj.INDEX = INDEX;
                obj.MAP_REPETITION_INDEX = MAP_REPETITION_INDEX;
                obj.CUSTOM_DB_FIELD = CUSTOM_DB_FIELD;
                obj.PLUGIN_NAME = PLUGIN_NAME;
                obj.WF_ITEM_ID = WF_ITEM_ID;
                obj.WF_ITEM_LOCATION = WF_ITEM_LOCATION;
                obj.SOURCE_REPEATING_FIELD = SOURCE_REPEATING_FIELD || undefined;
                newSelNode = obj;
            }
            return obj;
        });

        if (newSelNode) {
            dispatch(
                treeActions.setRightTreeSelectedNode({
                    screen: parentScreen,
                    type: rightTree.currentTab,
                    data: newSelNode,
                })
            );
            dispatch(
                treeActions.setNewRightTreeTranslatedData({
                    screen: parentScreen,
                    type: rightTree.currentTab,
                    data: updatedTranslatedData,
                })
            );
        }
    }

    const sourceTypeDropdownChange = (val) => {
        if (val !== "INBOUND_DATA") {
            setSourceNodeInfo({});
        }
    }

    const handleSourceNameSelect = (mapname) => {
    }

    const recordLoopControlValuesHandler = (values) => {
        const { PARENT, MAPNAME, RECORD_TYPE, ACTION, INDEX, MAP_REPETITION_INDEX, CUSTOM_DB_FIELD, PLUGIN_NAME, WF_ITEM_ID, WF_ITEM_LOCATION, SOURCE_REPEATING_FIELD } = values
        const updatedTranslatedData = eachDeep(cloneDeep(translatedData), (obj) => {
            if (obj && obj.key === selectedNode.key) {
                // Update properties based on values
                obj.LOOP_SOURCE_NAME = MAPNAME;
                obj.SOURCE_PARENT = PARENT;
                obj.SOURCE_TYPE = RECORD_TYPE;
                obj.ACTION = ACTION;
                obj.INDEX = INDEX;
                obj.MAP_REPETITION_INDEX = MAP_REPETITION_INDEX;
                obj.SOURCE_REPEATING_FIELD = SOURCE_REPEATING_FIELD || undefined;
                obj.CUSTOM_DB_FIELD = CUSTOM_DB_FIELD;
                obj.PLUGIN_NAME = PLUGIN_NAME
                obj.WF_ITEM_ID = WF_ITEM_ID
                obj.WF_ITEM_LOCATION = WF_ITEM_LOCATION

                dispatch(
                    treeActions.setRightTreeSelectedNode({
                        screen: parentScreen,
                        type: rightTree.currentTab,
                        data: obj,
                    })
                );
            }
            return obj;
        });
        dispatch(
            treeActions.setNewRightTreeTranslatedData({
                screen: parentScreen,
                type: rightTree.currentTab,
                data: updatedTranslatedData,
            })
        );
    }

    const getWorkflows = () => {
        const workflows = []
        inboundTemplateTree?.forEach((ele) => {
            if (ele?.type === 'workflowGroup') {
                workflows.push(ele.title);
            }
        })
        return workflows;
    }

    const getTemplatesInWorkflowGroup = (workflow) => {
        const templates = [];
        inboundTemplateTree?.forEach((ele) => {
            if (ele?.title === workflow) {
                ele?.children?.forEach(t => (
                    templates.push(t.title))
                );
                return;
            }
        })
        return templates;
    }

    // const handleDataDepotChange = (val) => {
    //     if (val) {
    //         dispatch(
    //             api.endpoints.getDataDepotFieldList.initiate({
    //                 account: queryParams.account,
    //                 dataDepotName: val,
    //             }, { forceRefetch: true })
    //         ).then((response) => {
    //             if (response?.data?.current_state === "SUCCESS") {
    //                 const dataField = Object.values(response?.data?.data.data_field_list);
    //                 setDepotField(dataField);
    //                 if (!dataField?.filter(e => e?.name === selectedNode?.DATA_DEPOT_FIELD)?.length || !selectedNode?.DATA_DEPOT_FIELD) { // Changed because response is also coming in object format
    //                     setDataFieldValue(dataField[0]?.name);
    //                     dataDepotHandler("DATA_DEPOT_FIELD", dataField[0]?.name);
    //                 } else {
    //                     setDataFieldValue(selectedNode.DATA_DEPOT_FIELD);
    //                 }
    //             } else if (response?.data?.current_state === "ERROR") {
    //                 setDepotField([]);
    //                 setAddDataDepot(true);
    //                 dataDepotHandler("DATA_DEPOT_FIELD", "");
    //                 setShowAlert({ mssg: response?.data?.message, isOpen: true, type: 'error' });
    //             }
    //         });
    //     }
    // };

    const handleAlertClose = () => {
      setShowAlert({ ...showAlert, isOpen: false });
    };

    const COMPONENT_MAPPING_OBJ = {
        VARIABLE_COLLECTION: <VariableCollection />,
        CUSTOM_DB_FIELD: <CustomDBField />,
        RECORD_LOOP_CONTROL: (
            <SourceType
                node={{
                    PARENT: selectedNode.SOURCE_PARENT,
                    MAPNAME: selectedNode.LOOP_SOURCE_NAME,
                    RECORD_TYPE: selectedNode.SOURCE_TYPE,
                    key: selectedNode.key,
                    ACTION: selectedNode?.ACTION,
                    INDEX: selectedNode?.INDEX,
                    MAP_REPETITION_INDEX: selectedNode?.MAP_REPETITION_INDEX,
                    CUSTOM_DB_FIELD: selectedNode?.CUSTOM_DB_FIELD,
                    PLUGIN_NAME: selectedNode?.PLUGIN_NAME
                }}
                valuesHandler={recordLoopControlValuesHandler}
                callerComponent='recordProperties'
            />
        ),
        INBOUND_DATA: (
            <SourceTypeInboundDataRenderer
                allowAllTreeSelection={true}
                treeData={treeData}
                expandActions={expandActions}
                setTab={setTab}
                handleSourceNameSelect={handleSourceNameSelect}
                valuesHandler={sourceTypeValueChange}
                src="INBOUND_DATA"
                node={{
                    PARENT: selectedNode.PARENT,
                    MAPNAME: selectedNode.LOOP_SOURCE_NAME,
                    RECORD_TYPE: selectedNode.TYPE,
                    key: selectedNode.key
                }}
                onlyRecord={true}
                isLoading={isLoading}
                showInboundTree={true}
            />
        ),
    };

    const loopRecordMenuItems = useMemo(
        () =>
            loopRecordOptions.map((obj, key) => (
                <MenuItem key={key} value={obj.value}>
                    {t(obj.title)}
                </MenuItem>
            )),
        [loopRecordOptions]
    );

    // const dataFieldDropDownItems = depotField?.map((obj, key) => (
    //     <MenuItem key={key} value={obj?.name}>
    //         {obj?.name}
    //     </MenuItem>
    // ));

    // const dataDepotDropDownItems = dataDepotOptions?.map((obj, key) => (
    //     <MenuItem key={key} value={obj}>
    //         {obj}
    //     </MenuItem>
    // ));

    useEffect(() => {
        if (loopRecordValue === "INBOUND_DATA") {
            const dependency = DEPENDENCIES?.split("/") || [];

            const workflow = dependency[0] || "";
            const template = dependency[2] || "";
            const workflows = getWorkflows();
            const templatesInWorkflow = getTemplatesInWorkflowGroup(workflow);

            if (
                workflows.includes(workflow) &&
                templatesInWorkflow.includes(template)
            ) {
                setIsLoading(true);
                dispatch(
                    api.endpoints.getInboundTemplateData.initiate(
                        {
                            workflowGroupName: workflow,
                            templateName: template,
                            account: account,
                        },
                        { forceRefetch: true }
                    )
                ).then((res) => {
                  if(res?.data?.current_state === "SUCCESS") {
                      const headerData = filterOutNodeTypes(
                          filterNodes(inboundTemplateToRcTree(res.data, "HEADER"), "header"),
                          []
                      );
                      const bodyData = filterOutNodeTypes(
                          filterNodes(inboundTemplateToRcTree(res.data, "BODY"), "body"),
                          []
                      );
                      const trailerData = filterOutNodeTypes(
                          filterNodes(
                              inboundTemplateToRcTree(res.data, "TRAILER"),
                              "trailer"
                          ),
                          []
                      );
                      setTreeData((prev) => {
                          return { header: headerData, body: bodyData, trailer: trailerData };
                      });
                  } else if(res?.data?.current_state === "ERROR") {
                      setShowAlert({ mssg: res.data.message, isOpen: true, type: 'error' });
                  }
                  
                  setIsLoading(false);
              }).finally(() => setIsLoading(false));
            } else setIsLoading(false);
        }
        setShowCheckbox(loopRecordValue !== 'RECORD_LOOP_CONTROL')

    }, [DEPENDENCIES, loopRecordValue])

    useEffect(() => {
        const options = paddingDirectionOptions?.map((obj, key) => {
            return <MenuItem key={key} value={obj.value}>
                {obj.text}
            </MenuItem>
        });
        setPaddingDirectionDropdown(options);
    }, [paddingDirectionOptions]);

    useEffect(() => {
        const fieldTypeOptions = [...outboundFieldTypeOptionsArray];
        setFieldTypeOptions(fieldTypeOptions);
    }, [templateHeader?.FILETYPE]);

    useEffect(() => {
        const options = convertCaseOptions?.map((obj, key) => {
            return <MenuItem key={key} value={obj.value}>
                {t(obj.text)}
            </MenuItem>
        });
        setConvertCaseDropdown(options)
    }, [convertCaseOptions]);

    useEffect(() => {
        const fieldTypeDropDownItems = fieldTypeOptions.map((obj, key) => (
            <MenuItem key={key} value={obj.value}>
                {t(obj.text)}
            </MenuItem>
        ));
        setFieldTypeDropDownItems(fieldTypeDropDownItems);
    }, [fieldTypeOptions]);

    useEffect(() => {
        const options = errorOptions?.map((obj, key) => {
            return <MenuItem key={key} value={obj.value}>
                {obj.text}
            </MenuItem>
        });
        setErrorDropdown(options);
    }, [errorOptions]);

    // useEffect(() => {
    //     if (dataDepotValue) handleDataDepotChange(dataDepotValue);
    // }, [dataDepotValue]);

    useEffect(() => {
        if (selectedNode?.children && selectedNode?.children.length > 0) {
            const field = selectedNode?.FIELD;
            setFillCharacter(field?.FILLCHAR === ' ' ? 'SPACE' : '');
            setPaddingDirection(field?.PADDIR || 'RIGHT');
            setConverCase(field?.CONVERT_CASE || 'DO_NOT_CONVERT');
            setInboundPrecision(field?.INPRECISION || 0);
            setOutboundPrecision(field?.OUTPRECISION || 0);
            setError(field?.ONERROR || '');
            setLength(field?.LENGTH || 0);
            setDefaultValue(field?.DEFAULT_VALUE || '');
            setFieldType(field?.FIELDTYPE || '');
            setRepeatTimes(field?.REPEAT || 1);
            setTrimData(stringToBooleanConversion(field?.TRIM_DATA) || false)
            setLoopRecordValue(field?.LOOP_REC_OPTIONAL || '');
            setConvertCaseOptions(convertCaseOptionsArray);
            setPaddingDirectionOptions(paddingDirectionArray);
            setLoopCounter(field?.CREATE_COUNTER_FOR_LOOP || false);
            setErrorOptions(errorArray);
            setAddToWorkflow(field?.ADD_TO_WF_SESSION || false);
        } else {
            setFillCharacter(selectedNode?.FILLCHAR || 'SPACE');
            setPaddingDirection(selectedNode?.PADDIR || 'RIGHT');
            setConverCase(selectedNode?.CONVERT_CASE || 'DO_NOT_CONVERT');
            setInboundPrecision(selectedNode?.INPRECISION || 0);
            setOutboundPrecision(selectedNode?.OUTPRECISION || 0);
            setLength(selectedNode?.LENGTH || 0);
            setError(selectedNode?.ONERROR || t('LEAVE_BLANK'));
            setDefaultValue(selectedNode?.DEFAULT_VALUE || '');
            setFieldType(selectedNode?.FIELDTYPE || 'ALPHA');
            setRepeatTimes(selectedNode?.REPEAT || 1);
            setTrimData(stringToBooleanConversion(selectedNode?.TRIM_DATA) || false)
            setLoopRecordValue(selectedNode?.LOOP_REC_OPTIONAL || '');
            setConvertCaseOptions(convertCaseOptionsArray);
            setPaddingDirectionOptions(paddingDirectionArray);
            setLoopCounter(selectedNode?.CREATE_COUNTER_FOR_LOOP || false);
            setErrorOptions(errorArray);
            setAddToWorkflow(selectedNode?.ADD_TO_WF_SESSION || false);
            // setAddDataDepot(selectedNode?.ADD_TO_DATA_DEPOT || false);
            setSessionValue(selectedNode?.WF_SESSION_NAME || "");
            setApplyFieldProperty(selectedNode?.APPLY_FIELD_PROPERTIES || false);
        }
        if (selectedNode?.ICON_DISPLAY === 'ELEMENT' || selectedNode?.ICON_DISPLAY === 'REPEATING_ELEMENT') {
            if (selectedNode?.ELEMENT_NAME) setElementName(selectedNode?.ELEMENT_NAME || '');
            else {
                const updatedString = selectedNode?.title.replace(/[<>]/g, "");
                setElementName(updatedString);
            }
        }
        if (selectedNode?.ICON_DISPLAY === 'ATTRIBUTE') {
            if (selectedNode?.ATTRIBUTE_NAME) {
                setAttributeName(selectedNode?.ATTRIBUTE_NAME || selectedNode?.title || '');
            }
        }
        // if (dataDepotValue && selectedNode.hasOwnProperty("DATA_DEPOT_FIELD")) {
        //     handleDataDepotChange(selectedNode.DATA_DEPOT);
        // }
        setApplyFieldProperty(selectedNode?.APPLY_FIELD_PROPERTIES || false);
        setSupressElements(selectedNode?.SUPPRESS_EMPTY_RECORDS || false)
        setSupressAttribute(selectedNode?.SUPP_ATTRIB_MSSNG_FIELD_IDENTIFIER || false)
    }, [selectedNode.key, selectedNode?.SUPPRESS_EMPTY_RECORDS, selectedNode?.SUPP_ATTRIB_MSSNG_FIELD_IDENTIFIER]);

    // useEffect(() => {
    //     if (addDataDepot) {
    //         dispatch(
    //             api.endpoints.getDataDepotList.initiate({
    //                 account: queryParams.account,
    //             }, { forceRefetch: true })
    //         ).then((response) => {
    //             if (response?.data?.current_state === "SUCCESS") {
    //                 const depotList = response.data?.data.data_depot_list;
    //                 if (depotList.length > 0) {
    //                     setDataDepotOptions(depotList);
    //                     setDataDepotValue(selectedNode.DATA_DEPOT || depotList[0]);
    //                     if (!selectedNode.DATA_DEPOT) {
    //                         dataDepotHandler("DATA_DEPOT", depotList[0]);
    //                         handleDataDepotChange(dataDepotValue);
    //                     }
    //                 }
    //             } else if(response?.data?.current_state === "ERROR") {
    //               setShowAlert({ mssg: response?.data?.message, isOpen: true, type: 'error' });
    //           }
    //         });
    //     }
    // }, [addDataDepot]);

    useEffect(() => {
        const options = [...LOOP_RECORD];
        setLoopRecordOptions(options);
        setLoopRecordValue(options[0].value);
    }, []);

    //data depot code -
  const [updatedSelectedNode, setUpdatedSelectedNode] = useState({...selectedNode});

  const saveNewData = (newNode, sNode, tData) => {
    let nNode = {...newNode};
    let updatedData = eachDeep(cloneDeep(tData), (obj, key, parentArr, ctx) => {
      if (typeof obj !== 'object') return;
      if (obj?.nodeId && obj.nodeId === sNode.nodeId) {
        Object.keys(newNode).forEach((prop) => {
          if (newNode[prop] === "" || newNode[prop] === undefined || newNode[prop] === null) {
            delete obj[prop];
            delete nNode[prop];
          } else {
            if (prop.toUpperCase() === prop || prop === "title") obj[prop] = newNode[prop];
          }
        });
      }
    });

    //prevent unnecessary dispatch
    if (isEqual(tData, updatedData) || isEqual(newNode, sNode)) return;
    
    //set new trans data to updatedData.
    dispatch(
      treeActions.setNewRightTreeTranslatedData({
        screen: parentScreen,
        type: rightTree.currentTab,
        data: updatedData,
      })
    );

    //set selectedNode to match.
    dispatch(
      treeActions.setRightTreeSelectedNode({
        screen: parentScreen,
        type: rightTree.currentTab,
        data: {...nNode, avoidSelection: true},
      })
    );
  }

  const debouncedNodeSave = useCallback(
    debounce((node, sNode, tData) => saveNewData(node, sNode, tData), 150, true), []
  )

  //this can be used if inbound field properties gets logic upgrade later
  // const modifyUpdatedNode = (prop, val, values) => {
  //   if (val !== "" && val !== undefined) {
  //     setUpdatedSelectedNode(prev => {
  //       return prop ? {...prev, [prop]: val} : {...prev, ...values}
  //     });
  //   } else {
  //     setUpdatedSelectedNode(prev => {
  //       return {...prev, [prop]: null}
  //     });
  //   }
  // }

  useEffect(() => {
    if (!isEqual(selectedNode, updatedSelectedNode)) return setUpdatedSelectedNode({...selectedNode});
  }, [selectedNode]);

  useEffect(() => {
    if (!isEqual(selectedNode, updatedSelectedNode)) return debouncedNodeSave(updatedSelectedNode, selectedNode, translatedData); 
  }, [updatedSelectedNode]);


    return (
        <Box sx={{ padding: "15px 15px" }}>
            <Stack spacing={"15px"}>
                <div className="flex">
                    {(selectedNode?.ICON_DISPLAY === 'ELEMENT' || selectedNode?.ICON_DISPLAY === 'REPEATING_ELEMENT') && <FormControl className={"width-100 margin-right-4"}>
                        <TextField
                            variant="outlined"
                            size="small"
                            label={t("LBL_ELEM_NAME")}
                            type="text"
                            name={"ELEMENT_NAME"}
                            value={elementName || ''}
                            autoComplete="off"
                            onChange={(e) => {
                                setElementName(e.target.value);
                                debounceChangeHandler('ELEMENT_NAME', e.target.value);
                            }}
                        />
                    </FormControl>}
                    {selectedNode?.ICON_DISPLAY === 'ATTRIBUTE' && <FormControl className={"width-100 margin-right-4"}>
                        <TextField
                            variant="outlined"
                            size="small"
                            label={t("LBL_ATTR_NAME")}
                            type="text"
                            name={"ATTRIBUTE_NAME"}
                            value={attributeName || ''}
                            autoComplete="off"
                            onChange={(e) => {
                                setAttributeName(e.target.value);
                                debounceChangeHandler('ATTRIBUTE_NAME', e.target.value);
                            }}
                        />
                    </FormControl>}
                    <FormControl variant="outlined" className="width-100" size="small">
                        <InputLabel id="ftDropdownLabel">{t("LBL_FLD_TYPE")}</InputLabel>
                        <Select
                            className={"width-100"}
                            MenuProps={{
                                PaperProps: {
                                    sx: {
                                        maxHeight: 300,
                                    },
                                },
                            }}
                            name={"FIELDTYPE"}
                            value={fieldType}
                            labelId="ftDropdownLabel"
                            label={t("LBL_FLD_TYPE")}
                            id="ftDropdown"
                            onChange={(e) => {
                                setFieldType(e.target.value);
                                debounceChangeHandler("FIELDTYPE", e.target.value);
                            }}>
                            {fieldTypeDropDownItems}
                        </Select>
                    </FormControl>
                </div>
                {selectedNode && selectedNode?.children?.length > 0 && <div className="flex">
                    <FormControl variant="outlined" size="small" sx={{ width: '43%' }} className="margin-right-4">
                        <InputLabel id="loopRecordDropdownLabel">
                            {t("LBL_LOOP_REC_OPTIONAL")}
                        </InputLabel>
                        <Select
                            className="width-100"
                            MenuProps={{
                                PaperProps: {
                                    sx: {
                                        maxHeight: 300,
                                    },
                                },
                            }}
                            name="loopRecord"
                            value={loopRecordValue || ''}
                            label={t("LBL_LOOP_REC_OPTIONAL")}
                            onChange={(e) => {
                                debounceChangeHandler("LOOP_REC_OPTIONAL", e.target.value);
                                handleLoopRecordChange(e);
                            }}>
                            {loopRecordMenuItems}
                        </Select>
                    </FormControl>
                    <TPCheckbox
                        label={t("BTN_CREATE_COUNTER_FOR_LOOP")}
                        checked={loopCounter}
                        handleCheck={(checked) => {
                            setLoopCounter(checked);
                            debounceChangeHandler("CREATE_COUNTER_FOR_LOOP", checked);
                        }}
                    />
                    <TPCheckbox
                        label={t("BTN_RESET_LOOP")}
                        checked={resetLoop}
                        handleCheck={(checked) => {
                            setResetLoop(checked);
                            debounceChangeHandler("RESET_LOOP", checked);
                        }}
                    />
                </div>
                }
                {loopRecordValue === "RECORD_LOOP_CONTROL" && (
                    <Typography sx={{ borderBottom: "solid 1px rgba(0,0,0,0.12)" }}>
                        {t("LBL_DATA_SOURCE")}
                    </Typography>
                )}

                {loopRecordValue === "INBOUND_DATA" && (
                    <div className="flex" style={{ justifyContent: "space-between" }}>
                        <Typography style={{ fontWeight: "bold" }}>
                            {t("LBL_SHOWING_LOOPS_ONLY")}
                        </Typography>
                    </div>
                )}

                {loopRecordValue && ['INBOUND_DATA', 'RECORD_LOOP_CONTROL', 'CUSTOM_DB_FIELD', 'VARIABLE_COLLECTION'].includes(loopRecordValue) && COMPONENT_MAPPING_OBJ[loopRecordValue]}
                {fieldType === 'CONSTANT' && <div className="flex">
                    <Autocomplete
                        className="width-100"
                        disablePortal
                        options={["", t("CRLF"), t("RECORD_DELIMITER")]}
                        getOptionLabel={(option) => option}
                        value={constantValue || ''}
                        sx={{ maxHeight: 300 }}
                        onChange={(e, value) => {
                            setConstantValue(value);
                            setLength(value !== '-- Select --' ? value?.length : '');
                            debounceChangeHandler('VALUE', value);
                        }}
                        onInputChange={(e, value) => {
                            setConstantValue(value);
                            setLength(value !== '-- Select --' ? value?.length : '');
                            debounceChangeHandler('VALUE', value);
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label={t("LBL_CONST_VAL")}
                                onChange={(e) => {
                                    const val = e.target.value;
                                    setConstantValue(val);
                                    setLength(val !== '-- Select --' ? val?.length : '');
                                    debounceChangeHandler('VALUE', e.target.value);
                                }}
                                variant="outlined"
                                size="small"
                                name={'VALUE'}
                                autoComplete="off"
                            />
                        )}
                    />

                    <Button
                        variant="outlined"
                        size="small"
                        disableElevation
                        className="margin-left-4"
                        sx={{
                            width: "40px",
                            padding: "4px 8px",
                            minWidth: "40px",
                        }}
                        onClick={() => {
                            setDelimiterDialog(true)
                        }}>
                        {t('BTN_ABC')}
                    </Button>
                </div>}
                <div className="flex">
                    <FormControl size="small" className="width-100 margin-right-4">
                        <TextField
                            variant="outlined"
                            size="small"
                            label={t("LBL_REPEAT_#_TIMES")}
                            className={"width-100"}
                            name={"REPEAT_#_TIMES"}
                            value={repeatTimes || ''}
                            onChange={(e) => {
                                const { value } = e.target;
                                const newValue = value.substring(0, 9).replaceAll(/\D/g, "");;
                                setRepeatTimes(newValue);
                                debounceChangeHandler("REPEAT", newValue);
                            }}
                        />
                    </FormControl>

                    {fieldType === 'CONSTANT' && <FormControl size="small" className="width-100">
                        <TextField
                            variant="outlined"
                            size="small"
                            label={t("LBL_LENGTH")}
                            className={"width-100"}
                            name={"LENGTH"}
                            disabled={fieldType === 'CONSTANT'}
                            value={length * repeatTimes || 0}
                            onChange={(e) => {
                                setLength(e.target.value);
                                debounceChangeHandler('LENGTH', e.target.value)
                            }}
                        />
                    </FormControl>}
                </div>
                <div>
                    {selectedNode?.ICON_DISPLAY !== 'ATTRIBUTE' && <TPCheckbox
                        label={t("BTN_CDATA_ELEM")}
                        checked={cdataElement}
                        disabled={selectedNode?.children && selectedNode?.children?.length !== 0}
                        handleCheck={(checked) => {
                            setCDataElement(checked);
                            debounceChangeHandler("CDATA_ELEM", checked);
                        }}
                    />}
                    <TPCheckbox
                        label={t("BTN_TRIM_DATA")}
                        checked={fieldType === 'CONSTANT' ? false : trimData}
                        disabled={fieldType === 'CONSTANT'}
                        handleCheck={(checked) => {
                            setTrimData(checked);
                            debounceChangeHandler("TRIM_DATA", checked);
                        }}
                    />
                    <TPCheckbox
                        label={t("BTN_URLENCODE_DATA")}
                        checked={urlEncodedData}
                        handleCheck={(checked) => {
                            setUrlEncodedData(checked);
                            debounceChangeHandler("URL_ENCODE_DATA", checked);
                        }}
                    />
                    <TPCheckbox
                        label={t("BTN_REPORT_TRUNCATION_ERRORS")}
                        checked={reportTransactionError}
                        handleCheck={(checked) => {
                            setReportTransactionError(checked);
                            debounceChangeHandler("REPORT_TRUNCATION_ERRORS", checked);
                        }}
                    />
                    <TPCheckbox
                        label={t("BTN_ALLOW_ROUNDING_FOR_FLOAT")}
                        checked={allowRounding}
                        disabled={fieldType !== 'FLOAT'}
                        handleCheck={(checked) => {
                            setAllowRounding(checked);
                            debounceChangeHandler("ALLOW_ROUNDING_FOR_FLOAT", checked);
                        }}
                    />
                    {selectedNode?.ICON_DISPLAY !== 'ATTRIBUTE' && <TPCheckbox
                        label={t("BTN_SUPPRESS_EMPTY_RECORDS")}
                        checked={suppressElements}
                        handleCheck={(checked) => {
                            setSupressElements(checked);
                            debounceChangeHandler("SUPPRESS_EMPTY_RECORDS", checked);
                        }}
                    />}
                    {selectedNode?.ICON_DISPLAY === 'ATTRIBUTE' && <TPCheckbox
                        label={t("BTN_SUPP_ATTRIB_MSSNG_FLD_IDENT")}
                        checked={suppressAttribute}
                        handleCheck={(checked) => {
                            setSupressAttribute(checked);
                            debounceChangeHandler("SUPP_ATTRIB_MSSNG_FLD_IDENT", checked);
                        }}
                    />}
                    <TPCheckbox
                        label={t("BTN_ESCAPE_XML")}
                        checked={selectedNode?.ICON_DISPLAY === 'ATTRIBUTE' ? false : escapeXmlData}
                        handleCheck={(checked) => {
                            setEscaepXmlData(checked);
                            debounceChangeHandler("ESCAPE_XML", checked);
                        }}
                    />
                    <TPCheckbox
                        label={t("BTN_QUOTE_DATA")}
                        checked={quoteData}
                        disabled={selectedNode?.ICON_DISPLAY === 'ATTRIBUTE'}
                        handleCheck={(checked) => {
                            setQuoteData(checked);
                            debounceChangeHandler("QUOTE_DATA", checked);
                        }}
                    />
                    <TPCheckbox
                        label={t("BTN_SUPPRESS_TRAILING_FLD_DELIM")}
                        checked={suppressTrailing}
                        disabled={selectedNode?.ICON_DISPLAY === 'ATTRIBUTE' || fieldType === 'CONSTANT'}
                        handleCheck={(checked) => {
                            setSuppressTrailing(checked);
                            debounceChangeHandler("SUPPRESS_TRAILING_FLD_DELIM", checked);
                        }}
                    />
                    <TPCheckbox
                        label={t("IGNORE_GLOBAL_SUB")}
                        checked={ignoreGlobal}
                        handleCheck={(checked) => {
                            setIgnoreGlobal(checked);
                            debounceChangeHandler("IGNORE_GLOBAL_SUB", checked);
                        }}
                    />
                    <TPCheckbox
                        label={t("BTN_FLD_REQ")}
                        checked={fieldRequired}
                        handleCheck={(checked) => {
                            setFieldRequired(checked);
                            debounceChangeHandler("FLD_REQ", checked);
                        }}
                    />
                    <div className="margin-bottom-4">
                        <TPCheckbox
                            label={t("BTN_ADD_TO_WF_SESSION")}
                            checked={addToWorkflow}
                            handleCheck={(checked) => {
                                setAddToWorkflow(checked);
                                if (checked) {
                                    setSessionValue(selectedNode?.ICON_DISPLAY === 'ATTRIBUTE' ? attributeName : elementName);
                                    debounceChangeHandler(
                                        "WF_SESSION_NAME",
                                        selectedNode?.ICON_DISPLAY === 'ATTRIBUTE' ? attributeName : elementName
                                    );
                                }
                                if (!checked) debounceChangeHandler("WF_SESSION_NAME", "");
                                debounceChangeHandler("ADD_TO_WF_SESSION", checked);
                            }}
                        />
                    </div>
                    {addToWorkflow && <div className="flex">
                        <FormControl className="margin-right-4" size="small" sx={{ width: '70%' }}>
                            <TextField
                                variant="outlined"
                                size="small"
                                className={"width-100"}
                                value={sessionValue || ''}
                                disabled={!addToWorkflow}
                                onChange={(e) => {
                                    setSessionValue(e.target.value);
                                    debounceChangeHandler('WF_SESSION_NAME', e.target.value)
                                }}
                            />
                        </FormControl>
                        <TPCheckbox
                            label={t("BTN_APPLY_FIELD_PROPERTIES")}
                            checked={applyFieldProperty}
                            disabled={!addToWorkflow}
                            handleCheck={(checked) => {
                                setApplyFieldProperty(checked);
                                debounceChangeHandler("APPLY_FIELD_PROPERTIES", checked);
                            }}
                        />
                    </div>}
                    {/* <div className="margin-top-4">
                        <TPCheckbox
                            label={t("BTN_ADD_TO_DATA_DEPOT")}
                            checked={addDataDepot}
                            handleCheck={(checked) => {
                                setAddDataDepot(checked);
                                dataDepotHandler('ADD_TO_DATA_DEPOT', checked);
                                if (!checked) dataDepotHandler(null, null, true);
                            }}
                        />
                    </div> */}
                </div>

                {updatedSelectedNode && <AddToDataDepot updatedSelectedNode={updatedSelectedNode} setUpdatedSelectedNode={setUpdatedSelectedNode} templateType="inbound"/>}
                
                {/* Data Source */}
                {(fieldType !== "CONSTANT") &&
                    <Accordion sx={styles.accordianContainer} defaultExpanded>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="accordianDataSource"
                            className="accordian-override"
                            id="accordianDataSource"
                            sx={styles.accordianHeader}
                        >
                            <SectionHeader text={t("LBL_DATA_SOURCE")} />
                        </AccordionSummary>
                        <AccordionDetails sx={styles.accordianContent}>
                            {/* <DataSourceSection /> */}
                            <SourceType
                                node={{
                                    PARENT: selectedNode?.PARENT,
                                    MAPNAME: selectedNode?.MAPNAME,
                                    RECORD_TYPE: selectedNode?.RECORD_TYPE,
                                    key: selectedNode?.key,
                                    ACTION: selectedNode?.ACTION,
                                    INDEX: selectedNode?.INDEX,
                                    MAP_REPETITION_INDEX: selectedNode?.MAP_REPETITION_INDEX,
                                    CUSTOM_DB_FIELD: selectedNode?.CUSTOM_DB_FIELD,
                                    PLUGIN_NAME: selectedNode?.PLUGIN_NAME
                                }}
                                valuesHandler={sourceTypeValueChange}
                                initialSelectCall={true} // Initial call required so added this props
                                sourceTypeDropdownChange={sourceTypeDropdownChange}
                            />
                        </AccordionDetails>
                    </Accordion>
                }

                {/* Formatting Options */}
                {(fieldType !== "CONSTANT") && <Accordion sx={styles.accordianContainer} defaultExpanded>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls='accordianFormattingOptions'
                        id='formattingOptions'
                        className='accordian-override'
                        sx={styles.accordianHeader}
                    >
                        <SectionHeader text={t("LBL_FORMATE_OPTIONS")} />
                    </AccordionSummary>
                    <AccordionDetails sx={styles.accordianContent}>
                        <Stack spacing={"10px"}>
                            {fieldType === 'DATE' && <> <FormControl className="width-100" size="small">
                                <div className="flex">
                                    <TextField
                                        variant="outlined"
                                        size="small"
                                        label={t("LBL_INBOUND_DATE_PATTERN")}
                                        className={"width-100"}
                                        value={inboundDate || ''}
                                        error={!valid}
                                        onChange={(e) => {
                                            setInboundDate(e.target.value);
                                            setInboundDatePattern(e.target.value);
                                            debounceChangeHandler('INBOUND_DATE_PATTERN', e.target.value);
                                            setDpNetworkCallMessage('');
                                            setFlag(false)
                                            setValid(true)
                                        }}
                                    />
                                    <Button
                                        variant="outlined"
                                        size="small"
                                        disableElevation
                                        className="margin-left-4"
                                        sx={{
                                            width: "40px",
                                            padding: "4px 8px",
                                            minWidth: "40px",
                                        }}
                                        onClick={() => setInboundDatePatternModal(true)}>
                                        <CalendarMonthOutlinedIcon fontSize="small"></CalendarMonthOutlinedIcon>
                                    </Button>
                                </div>
                                <div style={{ display: 'inline-block' }}>
                                    <p style={{ fontSize: '12px', margin: '10px' }}>{dpNetworkCallMessage}</p>
                                </div>
                            </FormControl>
                                <FormControl className="width-100" size="small">
                                    <div className="flex">
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            label={t("LBL_PATTERN")}
                                            className={"width-100"}
                                            value={date || ''}
                                            error={!valid}
                                            onChange={(e) => {
                                                setDate(e.target.value);
                                                setDatePattern(e.target.value)
                                                debounceChangeHandler('DATE_PATTERN', e.target.value)
                                                setDpNetworkCallMessage('');
                                                setFlag(false)
                                                setValid(true)
                                            }}
                                        />
                                        <Button
                                            variant="outlined"
                                            size="small"
                                            disableElevation
                                            className="margin-left-4"
                                            sx={{
                                                width: "40px",
                                                padding: "4px 8px",
                                                minWidth: "40px",
                                            }}
                                            onClick={() => setDatePatternModal(true)}>
                                            <CalendarMonthOutlinedIcon fontSize="small"></CalendarMonthOutlinedIcon>

                                        </Button>
                                    </div>
                                    <div style={{ display: 'inline-block' }}>
                                        <p style={{ fontSize: '12px', margin: '10px' }}>{dpNetworkCallMessage}</p>
                                    </div>
                                </FormControl>
                            </>
                            }
                            <div className="flex">
                                {fieldType !== 'DATE' && <FormControl variant="outlined" className="width-100 margin-right-4" size="small">
                                    <InputLabel id="convertCaseLabel">{t("LBL_CONVERT_CASE")}</InputLabel>
                                    <Select
                                        className={"width-100"}
                                        MenuProps={{
                                            PaperProps: {
                                                sx: {
                                                    maxHeight: 300,
                                                },
                                            },
                                        }}
                                        name={'CONVERTCASE'}
                                        value={convertCase || ''}
                                        labelId="convertCaseLabel"
                                        label={t("LBL_CONVERT_CASE")}
                                        id="convertCaseDropdown"
                                        onChange={(e) => {
                                            setConverCase(e.target.value);
                                            debounceChangeHandler('CONVERT_CASE', e.target.value);
                                        }}>
                                        {convertCaseDropdown}
                                    </Select>
                                </FormControl>}
                                <FormControl variant="outlined" className="width-100 margin-right-4" size="small">
                                    <InputLabel id="paddingDirectionLabel">{t("LBL_PADDING_DIRECTION")}</InputLabel>
                                    <Select
                                        className={"width-100"}
                                        MenuProps={{
                                            PaperProps: {
                                                sx: {
                                                    maxHeight: 300,
                                                },
                                            },
                                        }}
                                        name={'PADDINGDIRECTION'}
                                        value={paddingDirection || ''}
                                        labelId="paddingDirectionLabel"
                                        label={t("LBL_PADDING_DIRECTION")}
                                        id="paddingDirectionDropdown"
                                        onChange={(e) => {
                                            setPaddingDirection(e.target.value);
                                            debounceChangeHandler('PADDIR', e.target.value)
                                        }}>
                                        {paddingDirectionDropdown}
                                    </Select>
                                </FormControl>
                                <Autocomplete
                                    size="small"
                                    variant="outlined"
                                    className="width-100"
                                    freeSolo
                                    options={fillCharacterOptions}
                                    value={fillCharacter || ''}
                                    inputValue={fillCharacter}
                                    onChange={(event, newValue) => {
                                        setFillCharacter(newValue.value || "");
                                        debounceChangeHandler("FILLCHAR", newValue?.value || "");
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            autoComplete={"off"}
                                            {...params}
                                            onChange={(event) => {
                                                setFillCharacter(event.target.value);
                                                debounceChangeHandler("FILLCHAR", event.target.value);
                                            }}
                                            label={t("LBL_FILL_CHAR")}
                                        />
                                    )}
                                />
                            </div>
                            <div className="flex">
                                {fieldType !== 'CONSTANT' && <FormControl size="small" className="width-100 margin-right-4">
                                    <TextField
                                        variant="outlined"
                                        size="small"
                                        label={t("LBL_LENGTH")}
                                        name={"LENGTH"}
                                        value={length || ''}
                                        onChange={(e) => {
                                            const { value } = e.target;
                                            const newValue = value.substring(0, 9).replaceAll(/\D/g, "");;
                                            setLength(newValue);
                                            debounceChangeHandler('LENGTH', newValue)
                                        }}
                                    />
                                </FormControl>}
                                {(fieldType === 'FLOAT' || fieldType === 'INTEGER' || fieldType === 'PACKED_INT' || fieldType === 'ZONED_INT') && <FormControl className="width-100 margin-right-4" size="small">
                                    <TextField
                                        variant="outlined"
                                        size="small"
                                        label={t("LBL_PRECISION_IN")}
                                        className={"width-100"}
                                        name={"INPRECISION"}
                                        value={inboundPrecision || 0}
                                        onChange={(e) => {
                                            setInboundPrecision(e.target.value);
                                            debounceChangeHandler('INPRECISION', e.target.value)
                                        }}
                                    />
                                </FormControl>}
                                {(fieldType === 'INTEGER' || fieldType === 'PACKED_INT' || fieldType === 'ZONED_INT') && <FormControl className="width-100" size="small">
                                    <TextField
                                        variant="outlined"
                                        size="small"
                                        label={t("LBL_PRECISION_OUT")}
                                        className={"width-100"}
                                        name={"OUTPRECISION"}
                                        value={outboundPrecision || 0}
                                        onChange={(e) => {
                                            setOutboundPrecision(e.target.value);
                                            debounceChangeHandler('OUTPRECISION', e.target.value)
                                        }}
                                    />
                                </FormControl>}
                            </div>
                            {fieldType !== 'ALPHA' && fieldType !== 'CONSTANT' && <div className="flex">
                                <FormControl variant="outlined" size="small" className="width-100 margin-right-4">
                                    <InputLabel id="onErrorLabel">{t("LBL_ON_ERR")}</InputLabel>
                                    <Select
                                        MenuProps={{
                                            PaperProps: {
                                                sx: {
                                                    maxHeight: 300,
                                                },
                                            },
                                        }}
                                        name={'ERRORLBL'}
                                        value={error || ''}
                                        labelId="onErrorLabel"
                                        label={t("LBL_ON_ERR")}
                                        id="errorDropdown"
                                        onChange={(e) => {
                                            setError(e.target.value);
                                            debounceChangeHandler('ON_ERROR', e.target.value)
                                        }}>
                                        {errorDropdown}
                                    </Select>
                                </FormControl>
                                {error !== 'Keep Original Data' && <FormControl size="small" className={"width-100"}>
                                    <TextField
                                        variant="outlined"
                                        size="small"
                                        label={t("LBL_DEFAULT_VALUE")}
                                        name={"DEFAULTVALUE"}
                                        value={defaultValue || ''}
                                        onChange={(e) => {
                                            setDefaultValue(e.target.value);
                                            debounceChangeHandler('DEFAULT_VALUE', e.target.value)
                                        }}
                                    />
                                </FormControl>}
                            </div>}
                        </Stack>
                    </AccordionDetails>
                </Accordion>}
                <AdvancedProperties
                    selectedNode={selectedNode}
                    updatedSelectedNodeWithAdvanceProperties={updatedSelectedNodeWithAdvanceProperties}
                />
            </Stack>
            {openDelimiterDialog && <ReplacementModal
                openModal={openDelimiterDialog}
                closeModal={handleDelimiterDialog}
                inputValue={constantValue === '-- Select --' ? '' : constantValue}
                handleValue={handleDelimiterDialogValue}
                plugin={true}
            />}
            <DatePattern
                openModal={inboundDatePatternModal}
                docPath={docPath}
                okHandler={inboundDatePatternModalOkHandler}
                cancelHandler={dateInboundPatternModalCancelHandler}
                onChangeHandler={setInboundDatePattern}
                testDateHandler={testDateHandler}
                dpNetworkCallMessage={dpNetworkCallMessage}
                datePattern={inboundDatePattern}
                valid={valid}
                loading={datePatternLoader}
            />
            <DatePattern
                openModal={datePatternModal}
                docPath={docPath}
                okHandler={datePatternModalOkHandler}
                cancelHandler={datePatternModalCancelHandler}
                onChangeHandler={setDatePattern}
                testDateHandler={testDateHandler}
                dpNetworkCallMessage={dpNetworkCallMessage}
                datePattern={datePattern}
                valid={valid}
                loading={datePatternLoader}
            />
            <Snackbar open={showAlert.isOpen} onClose={() => handleAlertClose()}>
              <Alert
                onClose={() => handleAlertClose()}
                severity={showAlert.type}
                variant="filled"
                sx={{ width: "100%" }}
              >
                {showAlert.mssg}
              </Alert>
            </Snackbar>
        </Box>
    )
}

export default ElementProperties